export default function buildGetPublicUserFeedbacks({
    apiEndpoint,
    apiTools
}) {
    return async function getPublicUserFeedbacks(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/public/user` 
        })
       
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}